var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#6651BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8244 7.91873C16.1734 9.25805 17.3478 9.92772 17.742 10.802C18.0858 11.5646 18.0858 12.4354 17.742 13.198C17.3478 14.0723 16.1734 14.7419 13.8244 16.0813C11.4754 17.4206 10.301 18.0903 9.33721 17.9902C8.49659 17.903 7.73293 17.4675 7.2361 16.7922C6.6665 16.018 6.6665 14.6786 6.6665 12C6.6665 9.32135 6.6665 7.98203 7.2361 7.20778C7.73293 6.53245 8.49659 6.09703 9.33721 6.00978C10.301 5.90974 11.4754 6.57941 13.8244 7.91873Z",
    fill: "#6651BD",
    stroke: "#6651BD",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartProject);
export default __webpack_public_path__ + "static/media/start-project.3adda125feb72443544b75cae4d048da.svg";
export { ForwardRef as ReactComponent };